import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Flamme = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.97 82.2">
  <G fill={color}>
    <Path d="M4.01,19.88c.38,0,.76-.09,1.12-.26,1.24-.62,1.74-2.12,1.12-3.36l-1.51-3.02c-.62-1.24-2.12-1.73-3.36-1.12-1.24.62-1.74,2.12-1.12,3.36l1.51,3.02c.44.88,1.32,1.38,2.24,1.38Z"/>
    <Path d="M58.65,7.67c.38.2.79.3,1.19.3.89,0,1.75-.48,2.2-1.31l1.6-2.97c.66-1.22.21-2.73-1.01-3.39-1.22-.66-2.73-.2-3.39,1.01l-1.6,2.97c-.66,1.22-.21,2.73,1.01,3.39Z"/>
    <Path d="M74.35,22.73c-.91-1.04-2.49-1.14-3.53-.22l-2.53,2.23c-1.04.91-1.14,2.49-.22,3.53.49.56,1.18.85,1.88.85.59,0,1.18-.21,1.65-.62l2.53-2.23c1.04-.91,1.14-2.49.22-3.53Z"/>
    <Path d="M55.12,29.04c-5.49-4.64-15.78-17.04-14.69-24.71.13-.93-.27-1.86-1.04-2.4-.77-.54-1.78-.6-2.61-.16-13.96,7.43-13.89,24.05-11.45,34.1-2.26-.15-4.1-.85-5.35-2.05-1.51-1.45-2.16-3.63-1.94-6.47.08-1.03-.48-2.01-1.41-2.45-.93-.45-2.04-.27-2.8.44C.47,37.95-.51,48.03,2.23,60.22c2.78,12.33,16.6,21.99,31.46,21.99s30.41-13.48,31.87-27.75c1.36-13.29-5.96-21.63-10.44-25.41ZM33.69,73.95c-6.88,0-8.71-4.13-8.71-7.95,0-5.2,8.71-13.91,8.71-13.91,0,0,8.71,8.71,8.71,13.91,0,3.82-1.83,7.95-8.71,7.95Z"/>
  </G>
</Svg>
);
};

export default Flamme;
